import { FC, lazy, useState } from "react"
import { useNavigate } from "react-router-dom"
import { IStudent } from "types"
import { t } from "i18next"

import { Box, Grid } from "@mui/material"
import { Check, RadioButtonUnchecked } from "@mui/icons-material"

import MeetingForm from 'components/organisms/forms/MeetingForm'
import ExtendedSchoolYearForm from 'components/organisms/forms/special/ExtendedSchoolYearForm'
import AmendIEPForm from 'components/organisms/forms/special/AmendIEPForm'
import PriorNoticeForm from 'components/organisms/forms/special/PriorNoticeForm'



interface IProps {
    student: IStudent
    tabText?: string
    tabKey?: string
}

const Reevaluation: FC<IProps> = ({ student }) => {

    const navigate  =  useNavigate()

    const [step, setStep] = useState(0)

    const steps = [
        {title: t('special.student-follow-up-interview'), checked: false, component: <MeetingForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.parent-follow-up-interview'), checked: false, component: <MeetingForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.iep-team-follow-up-interview'), checked: false, component: <MeetingForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.extended-school-year'), checked: false, component: <ExtendedSchoolYearForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.amend-iep'), checked: false, component: <AmendIEPForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.prior-written-notice'), checked: false, component: <PriorNoticeForm action={'add'} id={''} viewOnly={false} /> },
    ]


    return <div style={{ padding: '0px' }}>    
        <Grid container>
            <Grid item xs={12} lg={3}>
                <div style={{ padding: '20px' }}>
                    <div style={{ padding: '20px', backgroundColor: '#f4f4f4', borderRadius: '5px' }}>
                        {steps.map((s, index) => <Box 
                            className='transparent-background' 
                            onClick={() => setStep(index)}
                            sx={{ 
                                display: 'flex', 
                                cursor: 'pointer', 
                                marginBottom: '20px',
                                fontWeight: step === index ? 'bold' : 'normal',
                                '&:hover': {
                                    fontWeight: 'bold'
                                }
                            }}>
                                {s.checked && <Check sx={{ color: '#7ED321', fontSize: '20px', marginRight: '10px' }} />}
                                {!s.checked && <RadioButtonUnchecked sx={{ fontSize: '20px', marginRight: '10px'  }} />}
                                {index+1}. {s.title}
                        </Box>)}
                    </div>
                </div>
            </Grid>
            <Grid item xs={12} lg={9}>
                <div style={{ padding: '20px' }}>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px'}}>{step+1}. {steps[step].title}</div>
                    {steps[step].component}    
                </div>
            </Grid>
        </Grid>
    </div>
}
export default Reevaluation